import React from "react";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import HelpCentre from "@/components/HelpCentre";
import GuidedTour from "@/components/GuidedTour";
import { OnboardingProvider } from "@/context/OnboardingContext";
import MobilePageHeader from "@/components/mobile/MobilePageHeader";

/**
 * App shell.
 *
 * Desktop / tablet ≥ 768px (unchanged): sidebar + top bar + main area.
 * Mobile < 768px:                       sidebar and top bar are hidden,
 *   the compact `MobilePageHeader` is shown at the top of the main area
 *   (contains hamburger to open MobileNavigationDrawer, page title,
 *   notifications, and an overflow menu for site switcher / theme /
 *   help / sign out).
 *
 * Uses 100dvh so the mobile browser chrome (URL/tab bars) never eats
 * the sticky action bars pinned to the bottom of long forms.
 */
export default function AppShell({ children }) {
  return (
    <OnboardingProvider>
      <div
        className="h-[100dvh] w-screen flex bg-slate-50 dark:bg-slate-950"
        data-testid="app-shell"
      >
        {/* Desktop-only sidebar (≥ lg / 1024px). Below that we use the
            mobile navigation drawer, which is cleaner for tablets too. */}
        <div className="hidden lg:flex shrink-0">
          <Sidebar />
        </div>

        <div className="flex-1 min-w-0 flex flex-col overflow-hidden">
          {/* Desktop-only top bar (≥ lg) — its 7 controls only fit on wider screens. */}
          <div className="hidden lg:block">
            <TopBar />
          </div>
          {/* Mobile + tablet compact header */}
          <MobilePageHeader />

          <main className="flex-1 min-w-0 overflow-hidden flex flex-col">
            {children}
          </main>
        </div>

        <HelpCentre />
        <GuidedTour />
      </div>
    </OnboardingProvider>
  );
}
